import React from "react"
import PropTypes from "prop-types"
import Layout from "../components/Layout"
import createCanonicalUrl from "../utils/createCanonicalUrl"
import TitleAndMetaTags from "../components/TitleAndMetaTags"
import { withStyles } from "@material-ui/core/styles"

import Team from "../components/Team"

const styles = {
  root: {
    width: "100%",
  },
}

const People = ({ location, classes }) => (
  <Layout location={location}>
    <TitleAndMetaTags
      title="People &ndash; DB System NUS"
      canonicalUrl={createCanonicalUrl("/people")}
    />
    <div className={classes.root}>
      <Team />
    </div>
  </Layout>
)

People.propTypes = {
  location: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(People)
